import { render, staticRenderFns } from "./mspo-fulltext.vue?vue&type=template&id=c459ae50&lang=pug"
import script from "./mspo-fulltext.vue?vue&type=script&lang=js"
export * from "./mspo-fulltext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports